export default "__VITE_ASSET__DuUXa3ON__"